import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTenderProfileCompareOptions extends Layout {
    buttonFrieghtItemFields: Button;
    buttonHandlingReqFields: Button;
    buttonMovementFields: Button;
    buttonOCFields: Button;
    buttonOrderFields: Button;
    buttonRefNoFields: Button;
    buttonStopFields: Button;
    checkboxAutoCompare: Checkbox;
    checkboxFreightItemAdd: Checkbox;
    checkboxFreightItemChange: Checkbox;
    checkboxFreightItemDelete: Checkbox;
    checkboxHandlingReqAdd: Checkbox;
    checkboxHandlingReqChg: Checkbox;
    checkboxHandlingReqDelete: Checkbox;
    checkboxMovementChange: Checkbox;
    checkboxNotesAdd: Checkbox;
    checkboxNotesDelete: Checkbox;
    checkboxOCAdd: Checkbox;
    checkboxOCChange: Checkbox;
    checkboxOCDelete: Checkbox;
    checkboxOrderChange: Checkbox;
    checkboxRefNoAdd: Checkbox;
    checkboxRefNoChange: Checkbox;
    checkboxRefnoDelete: Checkbox;
    checkboxStopAdd: Checkbox;
    checkboxStopChange: Checkbox;
    checkboxStopDelete: Checkbox;
    checkboxUpdateDatabase: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    label7: Label;
    labelAddColumn: Label;
    labelAutoCompareOptions: Label;
    labelChangeColumn: Label;
    labelDeleteColumn: Label;
    labelFreightItem: Label;
    labelHandlingReq: Label;
    labelMovementAdd: Label;
    labelMovementDelete: Label;
    labelMovements: Label;
    labelNoteChanges: Label;
    labelNotes: Label;
    labelOrderAdd: Label;
    labelOrderDelete: Label;
    labelOrders: Label;
    labelOtherCharges: Label;
    labelRefNo: Label;
    labelStopSequence: Label;
    labelStops: Label;
    panelAutoCompareOptions: Panel;
    panelCheckBoxes: Panel;
    panelColumnHeaders: Panel;
    panelCompareFieldsMain: Panel;
    panelCompareOptions: Panel;
    panelLeft: Panel;
    panelRight: Panel;
    panelRowLabels: Panel;
    panelStopSequence: Panel;
    sourceEdiorderProfileDisplay: DataSource;
    sourceEdipartnerXcmp: DataSource;
    textboxAutoCompareRt: Textbox;
    textboxNewStop: Textbox;
    textboxSequenceBy: Textbox;
}
